<div fxFlex fxLayout="column" fxLayoutAlign="center center">
  <div class="logo">
  </div>
  <div class="lds-ring">
    <div></div>
    <div></div>
    <div></div>
    <div></div>
  </div>
</div>

